import { blogPostsDataTwo } from "@/db/blogPostsData"
import { eventData } from "@/db/blogPostsData";
import Image from "next/image"
import Link from "next/link"

const eventArea = () => {
  return (
    <div className="blog-area pt-120 pb-95">
      <div className="container">
        <div className="section-title text-center">
          <h2 className="fs-3 fw-semibold mx-auto mb-0 text-uppercase">
            Campus Life & Events
          </h2>
        </div>
        <div
          className="row justify-content-center"    
        >
          {eventData
  .filter((blog) => [5, 6, 1].includes(blog.id))
  .map((blog) => (
    <div className="col-lg-4 col-md-6" key={blog.id}>
      <div className="single-post-box position-relative mb-25">
        <div className="image position-relative">
          <Link  href={{
          pathname: "/eventsDetails",
          query: { id: blog.id }, // 👈 use key:value (not just post.id)
        }} className="d-block">
            <Image
              width={416}
              height={364}
              sizes="100vw"
              src={blog.image}
              alt="blog-image"
            />
          </Link>
          <div className="date">{blog.date} {blog.month}</div>
          <Link  href={{
          pathname: "/eventsDetails",
          query: { id: blog.id }, // 👈 use key:value (not just post.id)
        }}
          
          className="default-btn">
            Read More
          </Link>

          
        </div>

        <div className="content">
          <h3 className="fw-semibold fs-5">
            <Link  href={{
          pathname: "/eventsDetails",
          query: { id: blog.id }, // 👈 use key:value (not just post.id)
        }}>{blog.title}</Link>
          </h3>
          {blog.description && <p className="fs-6">{blog.description}</p>}
          <Link
             href={{
          pathname: "/eventsDetails",
          query: { id: blog.id }, // 👈 use key:value (not just post.id)
        }}
            className="link-btn fw-medium d-inline-block"
          >
            Read More
          </Link>
        </div>
      </div>
    </div>
  ))}


        </div>
      </div>
    </div>
  )
}

export default eventArea
